import { ETH } from '../types';
export default {
  type: ETH,
  service: 'infura.io-ws',
  url: 'wss://mainnet.infura.io/ws',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
